import { useEffect, useState } from "react";

const BASE_URL = "https://be-ofertas.utpl.edu.ec";

const DataFetcherPosgrados = ({ url, children }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // 🔥 Obtener UNA imagen (Media -> File -> URL)
  const getImageUrl = (node, included, fieldName) => {
    const mediaId = node.relationships?.[fieldName]?.data?.id;
    if (!mediaId) return null;

    const media = included.find(
      (item) => item.type === "media--image" && item.id === mediaId,
    );

    const fileId = media?.relationships?.field_media_image?.data?.id;
    if (!fileId) return null;

    const file = included.find(
      (item) => item.type === "file--file" && item.id === fileId,
    );

    return file?.attributes?.uri?.url || null;
  };

  // 🔥 Obtener MUCHAS imágenes (por si el campo es múltiple)
  const getImageUrls = (node, included, fieldName) => {
    const mediaItems = node.relationships?.[fieldName]?.data;
    if (!Array.isArray(mediaItems)) return [];

    return mediaItems
      .map((item) => {
        const media = included.find(
          (inc) => inc.type === "media--image" && inc.id === item.id,
        );

        const fileId = media?.relationships?.field_media_image?.data?.id;

        const file = included.find(
          (inc) => inc.type === "file--file" && inc.id === fileId,
        );

        return file?.attributes?.uri?.url
          ? BASE_URL + file.attributes.uri.url
          : null;
      })
      .filter(Boolean);
  };

  // 🔥 NUEVA FUNCIÓN: Obtener la lista de docentes procesada
  const getDocentes = (node, included) => {
    const docentesRef = node.relationships?.field_nuestros_docentes?.data;
    if (!Array.isArray(docentesRef)) return [];

    return docentesRef
      .map((ref) => {
        const docenteNode = included.find(
          (inc) => inc.type === "node--docente" && inc.id === ref.id,
        );

        if (!docenteNode) return null;

        // 🔥 IMPORTANTE: Cambiar aquí a 'field_imagen_docente'
        const fotoPath = getImageUrl(
          docenteNode,
          included,
          "field_imagen_docente",
        );

        return {
          id: docenteNode.id,
          nombre: docenteNode.attributes?.title,
          // Usamos el campo field_contenido que mencionaste
          contenido: docenteNode.attributes?.field_contenido?.processed || "",
          foto: fotoPath ? BASE_URL + fotoPath : null,
        };
      })
      .filter(Boolean);
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (!url) throw new Error("URL no proporcionada");

        const response = await fetch(url);
        if (!response.ok) throw new Error(`Error ${response.status}`);

        const json = await response.json();

        const node = json?.data;
        const atributos = node?.attributes;
        const included = json?.included || [];

        if (!atributos) {
          throw new Error("Estructura inesperada de la API");
        }

        const brochureId = node.relationships?.field_brochure?.data?.id;
        const brochureFile = included.find(
          (item) => item.type === "file--file" && item.id === brochureId,
        );

        const brochureUrl = brochureFile?.attributes?.uri?.url
          ? BASE_URL + brochureFile.attributes.uri.url
          : null;

        const mallaId =
          node.relationships?.field_archivo_malla_curricular?.data?.id;
        const mallaFile = included.find(
          (item) => item.type === "file--file" && item.id === mallaId,
        );

        const mallaUrl = mallaFile?.attributes?.uri?.url
          ? BASE_URL + mallaFile.attributes.uri.url
          : null;

        const archivo1Id = node.relationships?.field_archivo1?.data?.id;
        const archivo1File = included.find(
          (item) => item.type === "file--file" && item.id === archivo1Id,
        );

        const archivo1Url = archivo1File?.attributes?.uri?.url
          ? BASE_URL + archivo1File.attributes.uri.url
          : null;

        // 🔥 Procesar Imágenes Principales
        const imagePortada = getImageUrl(
          node,
          included,
          "field_imagen_portada",
        );
        const imagePerfil = getImageUrl(
          node,
          included,
          "field_imagen_perfil_de_egreso",
        );
        const imagenIngreso = getImageUrl(
          node,
          included,
          "field_imagen_perfil_ingreso",
        );
        const imageRequisitos = getImageUrl(
          node,
          included,
          "field_imagen_requisitos",
        );
        const imageDirector = getImageUrl(
          node,
          included,
          "field_imagen_director",
        );
        const imagen1 = getImageUrl(node, included, "field_imagen1");

        // 🔥 Procesar Lista de Docentes
        const listaDocentes = getDocentes(node, included);

        const cleanData = {
          id: node.id,
          titulo: atributos.title,
          titulo_recibir: atributos.field_titulo,
          precio: atributos.field_precio,
          duracion: atributos.field_duracion,
          modalidad: atributos.field_modalidad,
          etiqueta_modalidad: atributos.field_etiqueta_modalidad?.processed,
          campo: atributos.field_campo_amplio,
          resolucion: atributos.field_resolucion?.processed,
          inicio: atributos.field_inicio_clases,
          ingreso: atributos.field_perfil_de_ingreso?.processed,
          egreso: atributos.field_perfil_de_egreso?.processed,
          ingreso_amplio: atributos.field_perfil_de_ingreso_amplio?.processed,
          egreso_amplio: atributos.field_perfil_de_egreso_amplio?.processed,
          requisitos: atributos.field_requisitos_de_postulacion?.processed,
          malla: atributos.field_malla_curricular?.processed,
          info1: atributos.field_atributo_1?.processed,
          info2: atributos.field_atributo_2?.processed,
          info3: atributos.field_atributo_3?.processed,
          field_texto_portada: atributos.field_texto_portada,
          field_publicado: atributos.field_publicado,
          field_enlace_postulacion: atributos.field_enlace_postulacion,
          diferencia1: atributos.field_diferencia_1?.processed,
          diferencia2: atributos.field_diferencia_2?.processed,
          diferencia3: atributos.field_diferencia_3?.processed,
          director: atributos.field_texto_director?.processed,
          bloque1: atributos.field_bloque1?.processed,

          // ✅ Datos listos para usar
          imagen_portada: imagePortada ? BASE_URL + imagePortada : "",
          imagen_perfil: imagePerfil ? BASE_URL + imagePerfil : "",
          imagen_director: imageDirector ? BASE_URL + imageDirector : "",
          imagen_requisitos: imageRequisitos ? BASE_URL + imageRequisitos : "",
          imagen_ingreso: imagenIngreso ? BASE_URL + imagenIngreso : "",
          imagen1: imagen1 ? BASE_URL + imagen1 : "",

          // ✅ Lista de docentes procesada
          nuestros_docentes: listaDocentes,
          brochure: brochureUrl,
          malla_curricular: mallaUrl,
          archivo1: archivo1Url,

          galeria: getImageUrls(node, included, "field_gallery"),
        };

        setData(cleanData);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [url]);

  if (loading) return <p>Cargando...</p>;
  if (error) return <p>Error: {error}</p>;

  return children(data);
};

export default DataFetcherPosgrados;
